import { IFrameApi } from "./shared/iframe-api"
import { RemoteProxy } from "penpal/dist/penpal"
import { RefObject, useEffect } from "react"
import { IFCViewerV4ConfigOptions, parseAndSanitizeUrls } from "./config"
import { useLatest } from "../../../hooks/use-latest"
import { toAbsoluteUrl, getEncodedPathName } from "./urls"

export function useSyncModelUrls(conf: {
  type: "ifc" | "frag"
  iframeLoadedAt: number
  iframeApiRef: RefObject<RemoteProxy<IFrameApi> | undefined>
  urls: string | null | undefined
  multipleselectparametertype: IFCViewerV4ConfigOptions["multipleselectparametertype"]
  onModelsLoaded?: () => void
}) {
  const latestConf = useLatest(conf)

  useEffect(() => {
    const conf = latestConf.current
    const iframeApi = conf.iframeApiRef.current
    if (!iframeApi) return

    async function sync() {
      const urls = parseAndSanitizeUrls(conf.urls, conf.multipleselectparametertype)
      const absoluteUrls = urls.map(url => toAbsoluteUrl(getEncodedPathName(url)))

      await (conf.type === "ifc"
        ? iframeApi!.setIfcUrls(absoluteUrls)
        : iframeApi!.setFragmentUrls(absoluteUrls))

      conf.onModelsLoaded?.()
    }

    sync().catch(e => console.error(`Error syncing ${conf.type} files`, e))
  }, [
    conf.iframeApiRef,
    conf.iframeLoadedAt,
    conf.type,
    conf.urls,
    latestConf
  ])
}
